import { GQLIconTilesFragment } from '@theprintbar/graphql';
import { BrandColours, cn, hexToRGBAString } from '@theprintbar/shared';
import { RichText } from '@theprintbar/ui';

interface IconTilesProps {
	content: GQLIconTilesFragment;
}

export const IconTiles = ({ content }: IconTilesProps) => {
	const colour = content.iconTilesColour || BrandColours.Blue;
	return (
		<div className="grid grid-cols-1 lg:grid-cols-3 gap-8 mx-4 lg:mx-8 my-20 lg:my-32">
			<div className="lg:col-span-1">
				<h2 className="font-light text-2xl lg:text-3xl normal-case">{content.iconTilesContainer.structure?.title}</h2>
				{content.iconTilesContainer.structure?.text && <p className="text-sm">{content.iconTilesContainer.structure.text}</p>}
			</div>
			<div className="lg:col-span-2 grid grid-cols-1 lg:grid-cols-2 gap-7">
				{content?.iconTiles?.structure?.map((item, index) =>
					item ? (
						<div
							className={cn('rounded-3xl border border-blue p-8 relative')}
							style={{ backgroundColor: hexToRGBAString(colour, (index + 1) * 0.1) }}
							key={index}
						>
							<h4 className="mb-3 uppercase lg:text-lg text-base">{item?.title}</h4>
							<RichText {...item.text} />
							{item?.icon && (
								<img
									loading="lazy"
									src={item.icon.image.url}
									alt={item.icon.altText || 'icon image'}
									className="h-12 w-12 rounded-full absolute top-0 right-4 -translate-y-1/2"
								/>
							)}
						</div>
					) : null,
				)}
			</div>
		</div>
	);
};
